import Colors from 'bit/mobiauto.web-ui-components.components.colors/colors';

export default {
  fontFamily: 'Poppins Regular',
  color: Colors.gray.dark,
};
